<template>
    <svg fill="#9BA2B6" height="17" viewBox="0 0 23 17" width="23" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.675 3.584c0-1.98 1.646-3.584 3.676-3.584 2.03 0 3.676 1.605 3.676 3.584 0 1.98-1.646 3.585-3.676 3.585-2.03 0-3.676-1.605-3.676-3.585zm5.236 3.83h-3.12c-2.594 0-4.705 2.058-4.705 4.588v3.72l.01.058.262.08c2.477.755 4.629 1.007 6.4 1.007 3.458 0 5.463-.962 5.587-1.023l.246-.122h.026v-3.72c0-2.53-2.111-4.589-4.706-4.589zM6.649 7.168c2.03 0 3.676-1.605 3.676-3.585S8.679 0 6.649 0C4.62 0 2.973 1.605 2.973 3.584c0 1.98 1.646 3.585 3.676 3.585zm2.588 8.554v-3.72a5.35 5.35 0 0 1 1.6-3.805 4.765 4.765 0 0 0-2.628-.785h-3.12c-2.594 0-4.706 2.059-4.706 4.59v3.72l.01.057.264.08c2.476.755 4.627 1.007 6.398 1.007 1.127 0 2.095-.103 2.898-.242l-.607-.186-.109-.716z"
            fill-rule="nonzero"
        />
    </svg>
</template>
<script>
export default {
    name: "User",
};
</script>
